export default __webpack_public_path__ + "9760bc8defb67c2f0833d7c72ded827d.png";